import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext'; // 👈 Importamos el contexto
import './i18n'; // Asegura que i18n se cargue al inicio

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ⬅️ Envolvemos toda la App */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);